import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../../../firebase";
import { useEffect, useMemo, useRef, useState } from "react";
import { AlertValue, alertOpen } from "../../../features/alert.slice";
import { Spiner } from "../../../components/spinner/Spiner";
import userQuery from "../../../firestore/User.query";
import pointDataQuery from "../../../firestore/PointData.query";
import { ConstMessage } from "../../../config/const";

export const PointHistoryWebHeldPointInfo = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ログイン中のユーザ情報
  const currentUser = auth.currentUser;
  const href = useRef<string>(window.location.href);

  const [isLoad, setIsLoad] = useState(true);
  const [ownedPoint, setOwnedPoint] = useState<number>(0);
  const [lapsePoint, setLapsePoint] = useState<number>(0);
  const [possessedPointMap, setPossessedPointMap] = useState<any[]>([]);
  const [expirationPointMap, setExpirationPointMap] = useState<any[]>([]);

  const location = useLocation();

  useEffect(() => {
    const windowBreakPoint = 1024;
    if (href.current.includes('eventParticipationWeb')) {
      if (window.innerWidth < windowBreakPoint) {
        // 画面幅が1024px未満の場合
        navigate(`/portal/pointHistoryListMobile/heldPointInfo`);
      }
    } else {
      if (window.innerWidth >= windowBreakPoint) {
        // 画面幅が1024px以上の場合
        navigate(`/portal/pointHistoryListWeb/heldPointInfo`);
      }
    }
  },[location.pathname, navigate]);

  useMemo(() => {
    const f = async () => {
      try {
        // ユーザ情報取得
        const userData = await userQuery.getUserData(currentUser?.tenantId!, currentUser?.uid!);

        // ポイントカテゴリマスタ取得
        const pointCategories = await pointDataQuery.getPointCategoryList();

        // 保有ポイント数取得
        let heldPoints = 0;
        if(userData?.possessedPointMap){
          // 現在の保有ポイント数
          const keys = Object.keys(userData.possessedPointMap);
          if(keys && keys.length > 0){
            for(let i = 0; i < keys.length; i++){
              const key = Number(keys[i]);
              heldPoints = heldPoints + (userData.possessedPointMap[key].point ?? 0);
            };
          };
        };
        setOwnedPoint(heldPoints);

        // 失効ポイント数取得
        let expirationPoint = 0;
        if(userData?.expirationPointMap){
          // 現在の保有ポイント数
          const keys = Object.keys(userData.expirationPointMap);
          if(keys && keys.length > 0){
            for(let i = 0; i < keys.length; i++){
              const key = Number(keys[i]);
              expirationPoint = expirationPoint + (userData.expirationPointMap[key].point ?? 0);
            };
          };
        };
        setLapsePoint(expirationPoint);

        // ポイントカテゴリごとの保有ポイントリスト・失効ポイントリストを作成
        let possessedPointMapList:any[] = [];
        let expirationPointMapList:any[] = [];
        pointCategories.map((category, i) => {
          // 保有ポイントリスト作成
          if (userData?.possessedPointMap) {
            const possessedPointMap = userData.possessedPointMap[category.categoryId];
            if (possessedPointMap) {
              possessedPointMapList.push({
                id: category.categoryId,
                name: category.categoryName,
                point: possessedPointMap.point,
              })
            } else {
              possessedPointMapList.push({
                id: category.categoryId,
                name: category.categoryName,
                point: 0,
              });
            }
          } else {
            possessedPointMapList.push({
              id: category.categoryId,
              name: category.categoryName,
              point: 0,
            });
          }

          // 失効ポイントリスト作成
          if (userData?.expirationPointMap) {
            const expirationPointMap = userData.expirationPointMap[category.categoryId];
            if (expirationPointMap) {
              expirationPointMapList.push({
                id: category.categoryId,
                name: category.categoryName,
                point: expirationPointMap.point,
              })
            } else {
              expirationPointMapList.push({
                id: category.categoryId,
                name: category.categoryName,
                point: 0,
              });
            }
          } else {
            expirationPointMapList.push({
              id: category.categoryId,
              name: category.categoryName,
              point: 0,
            });
          }
        });
        setPossessedPointMap(possessedPointMapList);
        setExpirationPointMap(expirationPointMapList);

        setIsLoad(false);
      } catch (err :any) {
        console.error(err);
        let errorMessage = err.error;
        if (errorMessage === "ERR_NETWORK") {
          dispatch(alertOpen(AlertValue(ConstMessage.ERR_CONNECT_NETWORK, "danger")));
        } else {
          dispatch(alertOpen(AlertValue(ConstMessage.ERR_GET_POINT_INFO, "danger")));
        }
        setIsLoad(false);
      }
    }
    f();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.tenantId, dispatch]);

  const getDestinatione = () => {
    if (href.current.includes('pointHistoryListWeb')) {
      return "/portal/pointHistoryListWeb";
    } else {
      return "/portal/pointHistoryListMobile";
    }
  };

  return (
    <main>
      <div className="flex flex-col overflow-y-auto mb-5">
        <nav className="flex items-start px-4 py-3" aria-label="Breadcrumb">
          <button
            className="flex px-4 justify-center font-medium rounded-md shadow transition ease-in duration-200 rounded h-10 px-2 text-sm items-center text-orange-500 bg-white border-2 border-orange-500 hover:bg-orange-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 focus:ring-offset-orange-100"
            onClick={() => navigate(getDestinatione())}
          >
            <ChevronLeftIcon className="-ml-2 h-5 w-5" aria-hidden="true" />
            <span>戻る</span>
          </button>
        </nav>
        {isLoad ?
          <Spiner />
        :
          <>
            <div className="max-w-5xl pl-10 pr-3">
              <div className="flex flex-col">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">保有ポイント</h2>
                <div className="w-full max-w-[470px]">
                  <div className="text-gray-700 font-bold mb-2 mt-5">現在の保有ポイント数</div>
                  <div className="flex items-center justify-end pb-2">
                    <span className="text-xl font-bold"><span className="text-orange-500 text-3xl">{ownedPoint.toLocaleString()}</span> pt</span>
                  </div>
                  {
                    ownedPoint ?
                      possessedPointMap.map((list) => {return (
                        <div className="flex items-center justify-between mb-2">
                          <span className="pl-3">{list.name}</span>
                          <div className="text-right">
                            <span className="text-gray-500 text-lg">
                              <span className="text-orange-400 font-bold text-2xl">
                                {list.point.toLocaleString()}
                              </span> pt</span>
                          </div>
                        </div>
                      )})
                    :
                      <></>
                  }
                </div>
              </div>
            </div>

            <div className="my-3 mx-5 border-b" />

            {lapsePoint ? 
              <div className="max-w-5xl pl-10 pr-3 mb-5">
                  <div className="w-full max-w-[400px] ml-6">
                    <div className="flex items-center justify-between mb-3">
                      <span className="mt-2 text-gray-600 tex-sm">┗　直近1ヵ月で失効するポイント数</span>
                      <div className="text-right">
                        <span className="text-gray-900 text-base ml-1 text-lg font-bold"><span className="text-orange-500 text-2xl">{lapsePoint.toLocaleString()}</span> pt</span>
                      </div>
                    </div>
                    {
                      expirationPointMap.map((list) => {
                        return (
                          <div className="flex items-center justify-between mt-1 mb-2 ml-4">
                            <span className="text-gray-700">{list.name}</span>
                            <div className="text-right">
                              <span className="text-gray-500 text-lg ml-1"><span className="text-orange-400 text-2xl font-bold">{list.point.toLocaleString()}</span> pt</span>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
              </div>
            :
             <></>
            }
          </>
        }
      </div>
    </main>
  );
}